enum SavedAddressType {
  CUSTOM = "custom",
  HOME = "home",
  WORK = "work",
}

export type ReservedSavedAddressType = SavedAddressType.HOME | SavedAddressType.WORK;

export default SavedAddressType;
